import {Product} from '@hconnect/apiclient'
import {TextRegular} from '@hm/fundamental'
import React from 'react'

import {useTranslation} from '../../../hooks/useTranslation'

import {PillWithTooltip} from './PillWithTooltip'

type InvitationProduct = {
  product: Product
  invitationDate: string
}

type InvitationProductsProps = {
  invitationProducts: InvitationProduct[]
}

export const InvitationProducts = ({invitationProducts}: InvitationProductsProps) => {
  const {t} = useTranslation()

  if (invitationProducts.length === 0) {
    return <TextRegular>{t('manageUser.userNotInvited')}</TextRegular>
  }

  return (
    <div className="flex gap-2 flex-wrap">
      {invitationProducts.map((invitationProduct) => (
        <PillWithTooltip
          key={invitationProduct.product}
          pillValue={invitationProduct.product}
          tooltipValue={t('manageUser.invitedOn', {date: invitationProduct.invitationDate})}
        />
      ))}
    </div>
  )
}
